function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { asyncToGenerator as _asyncToGenerator } from "../../_virtual/_rollupPluginBabelHelpers.js";
import { useState, useCallback } from 'react';
import useDocumentsAppConfigs from "../useDocumentsAppConfigs.js";
import AnnotationField from "../../stores/AnnotationField.js";
import "../../types/index.js";
import join from 'url-join';
import useFetch from "./useFetch.js";
import getPdfFileName from "./getPdfFileName.js";
import SignatureResource from "./resources/SignatureResource.js";
import DocumentPartyResource from "./resources/DocumentPartyResource.js";
import DocumentResource from "./resources/DocumentResource.js";
import DocumentDownloadResource from "./resources/DocumentDownloadResource.js";
import { processSigningData, processManualData } from "./useUpdateDocument.js";

var toJsonPayload = function toJsonPayload(documentId, fields, currentUserId, currentUserPermissions, signature) {
  var currentUserFields = AnnotationField.getAssignedFields(fields, currentUserId, currentUserPermissions);
  var parties;
  var signingData;
  var manualData;
  var fieldsByDataType = AnnotationField.groupFieldsByDataType(currentUserFields, undefined, undefined, true);

  if (currentUserFields.length) {
    var partyResource = new DocumentPartyResource();

    if (signature) {
      signingData = processSigningData(fieldsByDataType.signing);
      partyResource.signature = new SignatureResource(signature);
    }

    manualData = processManualData(fieldsByDataType.manual);
    parties = [partyResource];
  }

  var documentResource = new DocumentResource({
    id: documentId
  });
  documentResource.isPersisted = true;
  return new DocumentDownloadResource({
    signingData: signingData,
    parties: parties,
    document: documentResource,
    manualData: manualData
  }).toJsonPayload({
    with: ['document', 'manualData', 'signingData', {
      parties: 'signature'
    }]
  });
};

var useCreateDocumentDownload = function useCreateDocumentDownload(additionalFileNameSuffix) {
  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      currentUserId = _useDocumentsAppConfi.currentUserId,
      currentUserPermissions = _useDocumentsAppConfi.currentUserPermissions;

  var _useFetch = useFetch({
    responseType: 'blob'
  }),
      response = _useFetch.response,
      post = _useFetch.post,
      loading = _useFetch.loading,
      error = _useFetch.error;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var createDownload = useCallback(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(documentId, fields, signature) {
      var blob, converted;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFile(undefined);
              _context.next = 3;
              return post(join('documents', documentId, 'downloads'), toJsonPayload(documentId, fields, currentUserId, currentUserPermissions, signature));

            case 3:
              blob = _context.sent;

              if (!response.ok) {
                _context.next = 8;
                break;
              }

              converted = new File([blob], getPdfFileName(response.headers.get('Content-Disposition'), additionalFileNameSuffix));
              setFile(converted);
              return _context.abrupt("return", converted);

            case 8:
              return _context.abrupt("return", undefined);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [post, response, additionalFileNameSuffix, currentUserId, currentUserPermissions]);
  return {
    isLoading: loading,
    file: file,
    createDownload: createDownload,
    error: error
  };
};

export default useCreateDocumentDownload;